import {z} from 'zod';

export const BatchJobProgressMessageSchema = z.object({
	code: z.number().int(),
	codeLabel: z.string(),
	objectId: z.number().int(),
	objectType: z.string(),
	objectLabel: z.string(),
	taskId: z.number().int(),
	taskName: z.string(),
	taskType: z.string(),
});

export type IBatchJobProgressMessageSchema = z.infer<
	typeof BatchJobProgressMessageSchema
>;
